/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {JSONable} from "@irian-ro/abstract-resource";

export class BankAccountAuditVOModel extends JSONable {
    uuid: string | null = null;
    iban: string | null = null;
    currencyCode: string | null = null;
    swiftCode: string | null = null;
    bankName: string | null = null;
    status: string | null = null;
    type: string | null = null;
    lastModifiedAt: string | null = null;
    lastModifiedBy: string | null = null;
}
